import { SS_CONTROL_TYPE } from '../constants/form-manager.constants';

export const getHeaderTitleText = ({ userKey, recordNumber, revisionNumber }) =>
  `${recordNumber ?? userKey ?? ''}${revisionNumber ? ` [${revisionNumber}]` : ''}`;

export const findFavorite = (entityType, recordNumber) => (favorite) =>
  favorite.EntityType === entityType && favorite.EntityKey === recordNumber;

export const getFlexValue = (width, inTable, controlType, inFieldGroup, isInHeader, parentType) => {
  const flexDefaultValue = `0 0 ${width}`;

  if ((inTable && controlType === SS_CONTROL_TYPE.TEXT_VIEW) || inFieldGroup) {
    return null;
  }

  if (isInHeader) {
    return '0 0 auto';
  }

  if (parentType === SS_CONTROL_TYPE.ADVANCED_TEXT_BOX) {
    return controlType === SS_CONTROL_TYPE.TEXT_BOX
      ? '1 1 0'
      : controlType === SS_CONTROL_TYPE.TEXT_VIEW
      ? '0 0 16.6667%'
      : flexDefaultValue;
  }

  return flexDefaultValue;
};
